<template>
  <component :is="realTag" :type="buttonType" :class="{ button: true, [buttonClass]: true, disabled }"
    ><slot
  /></component>
</template>

<script lang="ts" setup>
import type { NuxtLinkOptions } from '#app'
import type { DefineComponent } from 'vue'

const props = withDefaults(
  defineProps<{
    tag?: 'button' | 'submit' | 'a'
    variant?: 'primary' | 'link' | 'highlight'
    disabled?: boolean
  }>(),
  {
    tag: 'button',
    variant: 'primary'
  }
)

const buttonClass = computed(() => `button-${props.variant}`)
const buttonType = computed(() => {
  if (['button', 'submit'].includes(props.tag)) return props.tag
})

const realTag = computed<string | DefineComponent<NuxtLinkOptions>>(() => {
  if (props.tag === 'a') return defineNuxtLink({})
  return props.tag
})
</script>

<style lang="scss" scoped>
.button {
  cursor: pointer;
  font-weight: $semi-bold;
  display: inline-block;
  text-align: center;

  &-highlight,
  &-primary {
    border-radius: 3rem;
    color: #fff;
    width: 100%;
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    line-height: 1.5rem;
    margin-bottom: 1.25rem;
  }

  &-primary {
    background-color: $primary-500;
  }

  &-highlight {
    background-color: $highlight-500;
  }

  &-link {
    text-decoration: underline;
  }

  &.disabled {
    background-color: $gray-200;
    color: $primary-25;
  }
}
</style>
